import { v4 as uuidv4 } from "uuid";
import {
  deleteStorageAttachments,
  getLocalAttachmentFileKey,
  uploadStorageAttachment,
  validateAttachmentFiles,
} from "utils/attachmentUploads";
import {
  EMAIL_DRAFT_ATTACHMENT_STORAGE_PREFIX,
  MAX_EMAIL_DRAFT_ATTACHMENT_BYTES,
  MAX_EMAIL_DRAFT_ATTACHMENT_FILES,
} from "utils/emailDraftAttachmentConfig";

export const getEmailDraftAttachmentFileKey = (file) =>
  getLocalAttachmentFileKey(file);

export const validateEmailDraftAttachmentFiles = (
  nextFiles,
  currentFiles = [],
) =>
  validateAttachmentFiles({
    nextFiles,
    currentFiles,
    maxFiles: MAX_EMAIL_DRAFT_ATTACHMENT_FILES,
    maxFileSize: MAX_EMAIL_DRAFT_ATTACHMENT_BYTES,
    maxTotalSize: MAX_EMAIL_DRAFT_ATTACHMENT_BYTES,
    rejectDuplicates: true,
  });

const uploadOneEmailDraftAttachment = ({
  file,
  uploadSessionId,
  user,
  onProgress,
}) =>
  uploadStorageAttachment({
    file,
    user,
    onProgress,
    customMetadata: { uploadSessionId },
    buildStoragePath: ({ attachmentId, safeFileName }) =>
      [
        EMAIL_DRAFT_ATTACHMENT_STORAGE_PREFIX,
        user.uid,
        uploadSessionId,
        `${attachmentId}-${safeFileName}`,
      ].join("/"),
  });

export const uploadEmailDraftAttachments = async ({
  files = [],
  user,
  onProgress,
}) => {
  if (!files.length) return [];
  if (!user?.uid) {
    throw new Error("Authenticated user is required for attachments");
  }

  const uploadSessionId = uuidv4();
  const results = await Promise.allSettled(
    files.map((file) =>
      uploadOneEmailDraftAttachment({
        file,
        uploadSessionId,
        user,
        onProgress,
      }),
    ),
  );
  const uploadedAttachments = results
    .filter((result) => result.status === "fulfilled")
    .map((result) => result.value);

  if (results.some((result) => result.status === "rejected")) {
    await deleteEmailDraftAttachments(uploadedAttachments);
    throw new Error("Failed to upload one or more attachments");
  }

  return uploadedAttachments;
};

export const deleteEmailDraftAttachments = deleteStorageAttachments;
